exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-dot--active {\n  background-color: #6f39ff !important;\n}", ""]);

// exports
